export const MARKER_SIZE = 40;
export const MARKER_CENTER = MARKER_SIZE / 2;
export const MARKER_RADIUS = MARKER_SIZE / 2;
export const DEFAULT_TITLE_FIELD = 'full_name';
export const HOVERED_COLOR_ALPHA_SUFFIX = 'E6';
export const ACTIVATION_KEYS = ['Enter', ' '];
